import { store } from '@sonifi/wb-core/store/store';
import { buildApiParamsPagination } from '@sonifi/wb-widget/store/tableConfig/tableConfigInitialState';
import {
  clearRowsAndForm,
  getUserById,
  getUsers,
  initRowExpanded,
} from '../users/services/users.service';
import { TABLE_KEYS } from '@sonifi/wb-widget/store/tableConfig/tableConfigConstants';
import { LOADING_STATUS } from '@sonifi/wb-core/common/Constants';

// `showDeactivated=1` in the URL turns the "Hide deactivated users" toggle
// off. Any other value, or no value, keeps the default (hidden).
function buildUsersApiParams(request) {
  const url = new URL(request.url);
  return {
    ...buildApiParamsPagination(request),
    showDeactivated: url.searchParams.get('showDeactivated') === '1',
  };
}

function checkIfUsersAreLoaded(apiParams) {
  const state = store.getState();
  const {
    adminUsers: { loadingUsers, users, showDeactivated },
  } = state;
  const currentPagination = state.tableConfig.pagination[TABLE_KEYS.adminUsers];

  // If users are loaded and params match, just update expanded state without refetching
  if (
    loadingUsers === LOADING_STATUS.success &&
    users.length > 0 &&
    currentPagination &&
    currentPagination.page === apiParams.page &&
    currentPagination.pageSize === apiParams.pageSize &&
    currentPagination.query === apiParams.query &&
    currentPagination.sortBy === apiParams.sortBy &&
    currentPagination.sortDir === apiParams.sortDir &&
    showDeactivated === apiParams.showDeactivated
  ) {
    return true;
  }
  return false;
}

export async function loaderUsers({ request }) {
  const apiParams = buildUsersApiParams(request);

  store.dispatch(clearRowsAndForm());

  if (checkIfUsersAreLoaded(apiParams)) {
    return {};
  }

  await store.dispatch(getUsers(apiParams));
  return {};
}

export async function loaderUserById({ params, request }) {
  const { id } = params;
  const addUser = id === 'add';
  const expandedRowId = addUser ? null : parseInt(id);

  const apiParams = buildUsersApiParams(request);
  if (!checkIfUsersAreLoaded(apiParams)) {
    await loaderUsers({ request });
  }

  store.dispatch(initRowExpanded(expandedRowId, addUser));
  if (expandedRowId) {
    // Don't wait here because uses the internal loading in the WbTable
    store.dispatch(getUserById(expandedRowId));
  }
  return {};
}
